import { LayoutHOC } from 'base/ui/layout/layout';
import { createLogin } from './login';
import { IUserServices } from 'services/User/user_services';

export const createLoginPage = (layoutHOC: LayoutHOC, services: IUserServices) => {
    return layoutHOC(createLogin(services));
};
